import { Image, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutPlanningTitle extends Layout {
    imageChevronLess: Image;
    imageChevronMore: Image;
    imageDoubleChevronLess: Image;
    imageDoubleChevronMore: Image;
    labelMajorTitle: Label;
    labelMinorTitle: Label;
    panelMain: Panel;
    panelSplitterControl: Panel;
    panelTitles: Panel;
}
